export const fontSizeNumbers = {
  h1: 3.2,
  large: 2.2,
  regular: 1.6,
  small: 1.3,
};

export default {
  large: `${fontSizeNumbers.large}rem`,
  regular: `${fontSizeNumbers.regular}rem`,
  small: `${fontSizeNumbers.small}rem`,
  smallButton: "1.2rem",
  smallText: "1.2rem",
  standardButton: "1.333rem",
  superAdminButton: "2rem",
};
